import React from "react";
import BillingPage from "../../components/admin/BillingPage";
export default function Invoices() { return <BillingPage kind="invoice" />; }
